import React from 'react'
import { Box } from '@mui/material'
import BrandProfiles from './brand-profiles'
import BrandList from './brand-list'

export default function Brands() {
  return (
    <Box id='brands'>
      <BrandList />
      <BrandProfiles />
    </Box>
  )
}
